import { useNavigate, useSearchParams } from 'react-router-dom'
import { Header } from '@/components/Header'
import { PoweredByParkeze } from '@/components/PoweredByParkeze'
import { activeOrg, apiBase } from '@/services/api'
import { ModuleHost } from '@/shell/ModuleHost'
import { Announcements } from '@/shell/Announcements'
import { getRealmFromSession } from '@/hooks/useBranding'

/**
 * /reserve: the booking wizard is the `reservation-app` module from
 * modules.parkeze.com (logbook decision 21), under the site's own header --
 * the same module the operator console mounts, so this site is its first
 * consumer (decision 12).
 *
 * The home calendar's drag-select arrives as ?date=&startTime=&endTime=, and
 * goes in as the element's prefill. Finishing or backing out returns home.
 */
export default function ReservePage() {
  const navigate = useNavigate()
  const [params] = useSearchParams()

  return (
    <div className="h-dvh bg-background flex flex-col overflow-hidden">
      <Header />
      <Announcements operator={getRealmFromSession()} />
      <div className="flex-1 min-h-0">
        <ModuleHost
          id="reservation-app"
          major={1}
          label="booking wizard"
          attributes={{
            'api-base': apiBase(),
            'active-org': activeOrg(),
            'zone-ids': params.get('zones'),
            date: params.get('date'),
            'start-time': params.get('startTime'),
            'end-time': params.get('endTime'),
          }}
          events={{
            'reservation-created': () => navigate('/home', { replace: true }),
            cancelled: () => navigate('/home'),
          }}
        />
      </div>
      <PoweredByParkeze />
    </div>
  )
}
